function getClassMethods(prototype) {
    if (!prototype) {
        return [];
    }
    return Object.getOwnPropertyNames(prototype).filter((name) => typeof prototype[name] === 'function' && name !== 'constructor');
}
function getPulseMethods(settings, tracker) {
    return {
        settingsMethods: getClassMethods(Object.getPrototypeOf(settings)),
        trackerMethods: getClassMethods(Object.getPrototypeOf(tracker)),
        // sharedMethods: getClassMethods(PulseSharedServerService.prototype)
    };
}
export function createPulse(settings, tracker) {
    const { settingsMethods, trackerMethods } = getPulseMethods(settings, tracker);
    function pulse() {
        // eslint-disable-next-line prefer-rest-params
        tracker.cmd(arguments);
    }
    const pulseAsAny = pulse;
    for (const key of settingsMethods) {
        pulseAsAny[key] = settings[key].bind(settings);
    }
    for (const key of trackerMethods) {
        pulseAsAny[key] = tracker[key].bind(tracker);
    }
    pulseAsAny.settings = settings;
    pulseAsAny.tracker = tracker;
    return pulseAsAny;
}
//# sourceMappingURL=create-pulse.js.map